import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPost, apiDelete } from '../api/client.js';

export const useApiKeys = (clientId) =>
  useQuery({
    queryKey: ['api-keys', clientId],
    queryFn: () => apiGet(`/clients/${clientId}/api-keys`),
    enabled: !!clientId,
  });

export const useGenerateApiKey = (clientId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => apiPost(`/clients/${clientId}/api-keys`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['api-keys', clientId] }),
  });
};

export const useRevokeApiKey = (clientId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (keyId) => apiDelete(`/clients/${clientId}/api-keys/${keyId}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['api-keys', clientId] }),
  });
};
